import axios from '@/axios';

export async function getCauseOfDeaths(params) {
    const { data } = await axios.get("/cause_of_deaths/filter", { params });
    return data.data ? data.data : data;
}

export async function saveCauseOfDeath(id, data) {
    const method = id ? 'PUT' : 'POST';
    const url = id ? `/cause_of_deaths/${id}` : `/cause_of_deaths`;
    return await axios({ method, url, data: data });
}
